import commonFn from '@/commons/commonFunction';
import BaseAPI from '@/apis/base/baseApi';

class StaticReportPrintAPI extends BaseAPI {
  apiName = 'Report';
  controllerName = 'StaticReports';

  /**
   * Lưu tham số báo cáo
   * Request này sẽ đẩy tham số lên server và cache lại
   * Sau đó sẽ có 1 request gọi để render ra file pdf và stream về
   * Tình huống việc render chậm sẽ
   * @param {*} data : tham số
   */
  saveParamter(param) {
    //xử lý tham số date chuyển thành string bỏ time và múi giờ đi để lên server nhận đúng giá trị
    let fnParam = function (data) {
      if (!data) {
        return;
      }
      commonFn.processDateParam(data, function (value, field) {
        return typeof value.getFullYear === 'function';
      });
    };
    fnParam(param.DataParam);
    fnParam(param.TemplateParam);
    fnParam(param.MisaObject);

    const isPrintAsync = commonFn.checkIsPrintAsync(param);

    let url = [this.getAPIUrl(), isPrintAsync ? 'worker' : ''].join('/');

    return this.postAsync({
      url: url,
      data: param,
    });
  }
  
  /**
   * Hàm gọi worker in báo cáo cho các báo cáo in theo Worker
   * @param {*} key key cache tham số báo cáo
   * HMDuc2: 12/03/2024
   */
  printWorker(key){
     let request = {
      url: this.getAPIUrl() + `/print-worker/${key}`,
    };

    return this.getAsync(request);
  }

  /**
   * Lưu tham số nhiều báo cáo
   * Request này sẽ đẩy tham số lên server và cache lại
   * Sau đó sẽ có 1 request gọi để render ra file pdf và stream về
   * Tình huống việc render chậm sẽ
   * @param {*} data : tham số
   * dtnga3 (31.01.2023)
   */
  async saveParamterMulti(paramMulti) {
    //xử lý tham số date chuyển thành string bỏ time và múi giờ đi để lên server nhận đúng giá trị
    let fnParam = function (data) {
      if (!data) {
        return;
      }
      commonFn.processDateParam(data, function (value, field) {
        return typeof value.getFullYear === 'function';
      });
    };

    if (paramMulti && Array.isArray(paramMulti)) {
      paramMulti.forEach(param => {
        fnParam(param.DataParam);
        fnParam(param.TemplateParam);
        fnParam(param.MisaObject);
      });
      let url = [this.getAPIUrl(), 'SaveParameterMulti'].join('/');
      return await this.postAsync({
        url: url,
        data: paramMulti,
      });
    }
  }

  /**
   * xuất mẫu báo cáo
   * @param {string} key : key cache tham số
   * dtnga3 (31.01.2023)
   */
  async exportReportDataMulti(param) {
    var url = window._apis.StaticReportRender + `/exportMulti`;

    return await this.postAsync({url: url, data: param});
  }

  /**
   * Lấy link in báo cáo mẫu stimul
   * @param {string} key : key cache tham số
   */
  getPrintLink(key, fileName) {
    return [window._apis.StaticReportRender, 'view', key, fileName].join('/');
  }

  /**
   * Lấy link in báo cáo mẫu stimul custom
   * @param {string} key : key cache tham số
   */
  getPrintLinkCustom(key, reportFile, fileName) {
    return [
      window._apis.StaticReportRender,
      'view-custom',
      key,
      commonFn.removeFileExtension(reportFile),
      fileName,
    ].join('/');
  }

  /**
   * Lấy link down
   * @param {string} key : key cache tham số
   */
  getDownloadink(key, name, ext) {
    return [window._apis.StaticReportRender, 'download', key, name, ext].join('/');
  }

  /**
   * Lấy link down
   * @param {string} key : key cache tham số
   */
  getDownloadinkCustom(key, reportFile, name, ext) {
    return [
      window._apis.StaticReportRender,
      'download-custom',
      key,
      commonFn.removeFileExtension(reportFile),
      name,
      ext,
    ].join('/');
  }

  /**
   * Lấy cache param của báo cáo trước đó
   * @param {*} id
   * @returns
   * NCPHUOC 19/08/2022
   */
  getCacheParamReport(id) {
    const url = [this.getAPIUrl(), 'CacheParam', id].join('/');
    return this.getAsync({url});
  }

  /**
   * Check dữ liệu báo cáo
   * @param {*} param
   * @returns
   * NCPHUOC 16/09/2022
   */
  async getCheckDataReport(param) {
    const cacheKey = await this.saveParamterCheckData(param);
    if (cacheKey) {
      const url = [window._apis.StaticReportRender, 'CheckData', cacheKey].join('/');
      const res = await this.getAsync({url});
      return res;
    }
  }

  /**
   * Check dữ liệu báo cáo xuất khẩu xml
   * @param {*} param
   * @returns
   * nmtuan4 08.02.2023
   */
  async getCheckDataReportForExportXml(param) {
    const cacheKey = await this.saveParamterCheckData(param);
    if (cacheKey) {
      const url = [window._apis.StaticReportRender, 'CheckDataForExportXml', cacheKey].join('/');
      const res = await this.getAsync({url});
      return res;
    }
  }

  /**
   * Check dữ liệu báo cáo
   * @param {*} param
   * @returns
   * nmtuan4 10.10.2022
   */
  async getCheckExportDataReport(param) {
    const cacheKey = await this.saveParamterCheckData(param);
    if (cacheKey) {
      const url = [window._apis.StaticReportRender, 'CheckExportData', cacheKey].join('/');
      const res = await this.getAsync({url});
      return res;
    }
  }

  /**
   * Check dữ liệu tất cả báo cáo
   * @returns Promise
   * NCPHUOC 16/09/2022
   */
  async getCheckAllDataReport() {
    const cacheKey = await this.saveParamterCheckData({});
    if (cacheKey) {
      const url = [window._apis.StaticReportRender, 'CheckAllData', cacheKey].join('/');
      const res = await this.getAsync({url});
      return res;
    }
  }

  /**
   * Lưu tham số check báo cáo
   * @param {*} param
   * @returns
   * NCPHUOC 16/09/2022
   */
  saveParamterCheckData(param) {
    let url = [this.getAPIUrl(), 'ParamCheckData'].join('/');
    return this.postAsync({
      url: url,
      data: param,
    });
  }

  /**
   * Check dữ liệu báo cáo xuất khẩu xml
   * @param {*} param
   * @returns
   * nmtuan4 08.02.2023
   */
  async getCheckDataForSendLekima(param) {
    const cacheKey = await this.saveParamterCheckData(param);
    if (cacheKey) {
      const url = [window._apis.StaticReportRender, 'CheckDataForSendLekima', cacheKey].join('/');
      const res = await this.getAsync({url});
      return res;
    }
  }

  /**
   * Check tài khoản trước khi nộp báo cáo
   * @param {*} param
   * @returns
   * nmtuan4 08.02.2023
   */
  async getCheckAccount(param) {
    const cacheKey = await this.saveParamterCheckData(param);
    if (cacheKey) {
      const url = [window._apis.StaticReportRender, 'CheckAccount', cacheKey].join('/');
      const res = await this.getAsync({url});
      return res;
    }
  }

  /**
   * Lấy mẫu stimul
   * @param {*} type
   * @param {*} fileName
   * @param {*} databaseId
   * @returns
   */
  getDownloadReportLink(type, fileName) {
    return [window._apis.StaticReportRender, 'download', type, fileName.replace(/\.[^/.]+$/, '')].join('/');
  }
}

export default new StaticReportPrintAPI();
